import PropTypes from 'prop-types'

import { Images } from '~/assets'

import Styled from './dashboard-empty.styled'

const DashboardEmpty = ({ icon, title }) => {
  return (
    <Styled.EmptyDataContainer>
      <Styled.EmptyDataContent>
        <Styled.EmptyDataImage src={icon || Images.EmptyVesselDataIcon} alt='empty-dashboard-icon' />
        {title && <Styled.EmptyDataText>{title}</Styled.EmptyDataText>}
      </Styled.EmptyDataContent>
    </Styled.EmptyDataContainer>
  )
}

DashboardEmpty.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
}

export default DashboardEmpty